import { getUserobjects, createUserobject, updateUserobject, deleteUserobject } from '../api';
import md5 from 'md5';

const services = (dispatch, actions) => ({
  getProperties: () => {
    dispatch(
      actions.savedActions('LOADING_USER_OBJECTS', { type: 'savedProperties', loading: true })
    );
    getUserobjects({})
      .then((res) => {
        dispatch(
          actions.savedActions('GET_USER_OBJECTS', {
            type: 'savedProperties',
            data: res.data.data[res.data.type],
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  },
  getSavedProperties: () => {
    dispatch(
      actions.savedActions('LOADING_USER_OBJECTS', { type: 'savedProperties', loading: true })
    );
    getUserobjects({
      type: 'property',
      state: true,
      related: true,
    })
      .then((res) => {
        dispatch(
          actions.savedActions('GET_USER_OBJECTS', {
            type: 'savedProperties',
            data: res.data.data[res.data.type].map(({ data, ...userobject }) => {
              return {
                ...data,
                userobject,
              };
            }),
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  },
  getSavedSearches: () => {
    dispatch(
      actions.savedActions('LOADING_USER_OBJECTS', { type: 'savedSearches', loading: true })
    );
    getUserobjects({ type: 'search' })
      .then((res) => {
        dispatch(
          actions.savedActions('GET_USER_OBJECTS', {
            type: 'savedSearches',
            data: res.data.data[res.data.type],
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  },
  createUserobject: (type, payload) => {
    // const data = { ...payload, type_id: md5(payload.params) };
    payload.type_id = md5(payload.params);
    createUserobject(payload)
      .then((res) => {
        dispatch(
          actions.savedActions('CREATE_USER_OBJECT', {
            type,
            data: res.data.data[res.data.type],
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  },
  updateUserobject: (type, payload) => {
    updateUserobject(payload)
      .then((res) => {
        dispatch(
          actions.savedActions('UPDATE_USER_OBJECTS', {
            type,
            data: res.data.data[res.data.type],
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  },
  deleteUserObject: (type, payload) => {
    deleteUserobject(payload)
      .then((res) => {
        dispatch(actions.savedActions('DELETE_USER_OBJECT', { type, id: payload.id }));
      })
      .catch((err) => {
        console.log(err);
      });
  },
  isSaved: (userObjects, params, type) => {
    if (!userObjects) return false;

    return !!userObjects[type].filter(
      (x) => JSON.stringify(x.params) === JSON.stringify(params) && x.state
    ).length;
  },
});

export default services;
